import React from 'react'
import SarasTrans from '../../../../library/notifications/SarasTrans'

//starting with capital letter will ensure this is treated as a component
const DocHeaderLabel = ({col}) => {

    return (
        <span className="uiValue"><SarasTrans value={col.valF || col.val}/></span>
    );
}

export default DocHeaderLabel
